module.exports = __webpack_public_path__ + "static/media/IC_amplofly_team.deb89cea.svg";